export const BILLION = 1e9
export const MILLION = 1e6
export const THOUSAND = 1e3
export const TWO_THOUSAND = 2000
export const HUNDRED = 100
export const THREE_HUNDRED = 300
export const FIVE_HUNDRED = 500
export const EIGHT_HUNDARD_TWENTY = 820

export const ZERO = 0
export const ONE = 1
export const TWO = 2
export const THREE = 3
export const FOUR = 4
export const FIVE = 5
export const NINE = 9

export const FORTY_FIVE = 45
export const SIXTY_SIX = 66
export const SIXTY_FIVE = 65
export const THIRTY_THREE = 33
export const TWENTY_FIVE = 25
export const TWENTY = 20
export const FOURTY = 40
export const SIXTY = 60
export const EIGHTY = 80
export const FIFTY = 50
export const SEVENTY_FIVE = 75

export const ONE_HOUR = 3.6e+6
export const FIFTY_EIGHT_MINUTES = 3.48e+6
export const ONE_HUNDRED_TWENTY = 120
